import { LinkedAccount, LinkedAccountType } from "../LinkedAccount";

export class MockLinkedAccount implements LinkedAccount {
  public createdAt = "2023-06-13T08:22:24.328Z";
  public customData: Record<string, string> = {};
  public externalUuid = "uuid";
  public kind = LinkedAccountType.UBISOFT;
  public updatedAt = "2023-06-13T08:22:24.328Z";
}
